/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Assignment group element.
 */
export interface HardlinkElementLastmile { 
    /**
     * Type of goal entity, it can be an order (`ORDER`) or a shift (`SHIFT`).
     */
    type: HardlinkElementLastmileTypeEnum;
    /**
     * Key of the target entity (an order or a shift).
     */
    entity_key: string;
}
export enum HardlinkElementLastmileTypeEnum {
    ORDER = 'ORDER',
    SHIFT = 'SHIFT'
};



